import { useState } from 'react';
import { RazborFlow } from './RazborFlow';

export function App() {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        <header className="mb-5 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-semibold text-slate-900">Praxios</h1>
          <p className="text-slate-600 mt-1 text-sm sm:text-base">
            Разбор спецификации: покрытие, аналоги, допустимость эквивалента
          </p>
        </header>

        <main className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 sm:p-6 lg:p-8">
          <RazborFlow />
        </main>
      </div>
    </div>
  );
}

// Дропзона для загрузки файла — используется в RazborFlow.
export function Dropzone({
  file,
  onPick,
  hint,
  accept = '.xlsx,.xlsm,.xml,.zip',
}: {
  file: File | null;
  onPick: (f: File | null) => void;
  hint: string;
  accept?: string;
}) {
  const [drag, setDrag] = useState(false);
  return (
    <label
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDrag(false);
        const f = e.dataTransfer.files[0];
        if (f) onPick(f);
      }}
      className={`block w-full border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition-colors ${
        drag ? 'border-slate-900 bg-slate-50' : file ? 'border-emerald-400 bg-emerald-50' : 'border-slate-300 hover:border-slate-400'
      }`}
    >
      <input
        type="file"
        accept={accept}
        className="hidden"
        onChange={(e) => onPick(e.target.files?.[0] || null)}
      />
      {file ? (
        <div className="space-y-1">
          <div className="text-2xl">📄</div>
          <div className="font-medium text-slate-900 break-all">{file.name}</div>
          <div className="text-xs text-slate-500">{(file.size / 1024).toFixed(1)} КБ</div>
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); onPick(null); }}
            className="text-xs text-slate-500 underline hover:text-slate-700"
          >
            Заменить файл
          </button>
        </div>
      ) : (
        <div className="space-y-1">
          <div className="text-2xl">📂</div>
          <div className="text-slate-700 font-medium">Нажми или перетащи файл</div>
          <div className="text-xs text-slate-500">{hint}</div>
        </div>
      )}
    </label>
  );
}
